import {
  InputBase,
  Box,
  Button,
  ButtonGroup,
  Paper,
  Grow,
  Popper,
  MenuList,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  TextField,
  FormHelperText,
  Tab,
  Skeleton,
} from "@mui/material";
import { useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { makeStyles } from "@mui/styles";
import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DescriptionIcon from "@mui/icons-material/Description";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import ViewOffer from "../OfferLetter/ViewOffer";
import { useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  PreScreenCandidateEmailHelper,
  UpdateAtsJobKanbanHelper,
  UpdateAtsJobKanbanOfferHelper,
} from "../../helper/AtsJobKanbanHelper";
import { GetAtsCandidateJobHistoryHelper } from "../../helper/AtsCandidateJobHistoryHelper";
import TimeAgo from "../../../Base/views/TimeAgo";
import Avatar from "react-avatar";
import CreatableSearch from "../../../Base/views/CreatableSearch";
import {
  AddAtsJobStatusHelper,
  GetAtsJobStatusHelper,
} from "../../helper/AtsJobStatusHelper";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Mention, MentionsInput } from "react-mentions";
import MentionInputStyles from "./MentionStyles/MentionInputStyles";
import { GetAtsJobAccessUsersHelper } from "../../helper/AtsUserHelper";
import RequestFeedback from "./RequestFeedback";
import Popup from "../../../Base/views/Popup";
import { AddNotificationHelper } from "../../../Ancillary/Notification/helper/NotificationHelper";
import { APP_NAME } from "../../../../Constants/baseConstant";
import { getUserData } from "../../../Base/helper/baseFunctions";
import { DownloadAttachment } from "../../../Base/helper/baseFunctions";
import CommonDatePicker from "../../../Base/views/CommonDatePicker";
import history from "../../../../../history";
import { useDispatch, useSelector } from "react-redux";
import { EnableAddRequestAction } from "../../../../../store/Onboarding/Action";
import CustomRating from "../../../Base/views/Rating";
import { AddMenuHeadingAction } from "../../../../../store/Menu/Action";
import { addSessionData } from "../../../Base/helper/baseHelper";
import SendApprovalOfferLetter from "./SendApprovalOfferLetter";
import SendReshareOfferLetter from "./SendReshareOfferLetter";
import OfferLetterResponseStepper from "../../../ATSSettings/views/OfferLetter/OfferLetterResponseStepper";
import SendIcon from "@mui/icons-material/Send";
import { AddAssignedTaskAction } from "../../../../../store/ATS/MyTask/Action";
import PreScreenResponseViewer from "./AIJobPrescreening/PreScreenResponseViewer";
import { toast } from "react-toastify";
import { GetAtsPythonPreScreenScoreAction } from "../../../../../store/ATS/ProfileScore/Action";
import AICongifWarningPopup from "../../helper/Ancillary/AICongifWarningPopup";
import { fnGetAvailableJobMprHelper, fnGetJobMprHelper } from "../../helper/AtsMprRequestHelper";
import {GetOfferLetterTemplateResponseAction} from "../../../../../store/ATS/FormTemplate/Action";
const AtsCandidatePreview = ({
  setIsOnboard,
  setIsOffer,
  setElements,
  toggleDrawer,
  data,
  stageData,
  setCandidatePreview,
  setCandidateUpdate,
  currentJobData,
  offerdata,
  setCurrentData,
  tabValue,
  isAiJob = false,
  getKanbanData = () => { }
}) => {
  const useStyles = makeStyles({
    row: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    label: {
      fontSize: "0.75rem",
      fontWeight: 400,
      width: "130px",
      flexShrink: 0,
      color: "rgb(99, 115, 129)",
      height: "30px",
      lineHeight: "30px",
      margin: "4px 0px 4px 0px",
    },
    value: {
      display: "flex",
      flexFlow: "row wrap",
      alignItems: "center",
    },
  });
  const dispatch = useDispatch();
  const theme = useTheme();
  const date = new Date();
  const default_date = `${date?.getFullYear() +
    "-" +
    ("0" + (date?.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + date?.getDate()).slice(-2)
    }`;
  const options = ["Give FeedBack", "Request FeedBack"];
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [previewData, setPreviewData] = useState({
    stage_id: "",
    feedback: "",
    priority: "",
    ats_status_id: "",
    assignee: "",
    job_designation: "",
    job_location: "",
    mpr_info: "",
    replacement_employee_fk: "",
    replacement_ctc: "",
    replacement_target_date: ""
  });

  const [historyData, setHistoryData] = useState(null);
  const [errors, setErrors] = useState({});
  const userData = getUserData();
  const classes = useStyles();
  const [statusData, setStatusData] = useState({ load: true, values: [] });
  const [stagesData, setStagesData] = useState({ load: true, values: [] });
  const [assigneeData, setAssigneeData] = useState({ load: true, values: [] });
  const [mentionValue, setMentionValue] = useState("");
  const [mentionUsers, setMentionUsers] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [viewOffer, setViewOffer] = useState(false);
  const [openNotes, setOpenNotes] = useState(false);
  const [openprescreen, setOpenPreScreen] = useState(false);
  const [openreshare, setOpenReshare] = useState(false);
  const [openapprove, setOpenApprove] = useState(false);
  const [approverDetails, setApproverDetails] = useState("");
  const [isofferview, setIsOfferView] = useState(false);
  const [isofferedit, setIsOfferEdit] = useState(false);
  const [openEditOfferAlert, setOpenEditOfferAlert] = useState(false);
  const [value, setValue] = useState("1");
  const prescreenRef = useRef(null);
  const [showResponse, setShowResponse] = useState(false);
  const aiConfigPopupRef = useRef();
  const isAdminOwner = ["Admin", "Owner"].includes(userData?.user_type);
  const isMprReplacement = !!(previewData?.mpr_info?.hiring_type === "Replacement");
  const [jobMprInfo, setJobMprInfo] = useState("")
  const { offerletterResponseData, isOfferLetterResponseLoading } = useSelector((state) => state.AtsReducer?.FormTemplateReducer);
  const offerData = offerletterResponseData?.[0] || {};
  useEffect(() => {
    GetAtsCandidateJobHistoryHelper({
      candidate_job_id: data?.candidate_job_id,
    }).then((resp) => {
      setHistoryData(resp?.data?.data?.[0]?.candidatejob);
    });
    GetAtsJobAccessUsersHelper({ ats_jobpost_id: data?.ats_jobpost_id, candidate_job_id: data?.candidate_job_id }).then(
      (res) => {
        let arr = [];
        res?.data?.data?.forEach((temp) =>
          arr.push({
            ...temp,
            id: temp?.recruiter_id,
            display: temp?.recruiter,
          })
        );
        setMentionUsers(arr);
      }
    );
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (data) {
      const mprInfo = data?.mpr_info;
      setPreviewData({
        ...previewData,
        priority: data?.priority,
        stage_id: {
          ats_job_stages_id: data?.ats_job_stages_id,
          name: data?.job_stage_name,
        },
        ats_status_id: {
          ats_status_id: data?.ats_status_id,
          name: data?.job_status_name,
        },
        joined_ctc: data?.joined_ctc,
        accepted_ctc: data?.accepted_ctc,
        joined_date: data?.joined_date || default_date,
        offer_released_date: data?.offer_released_date || default_date,
        tentative_joining_date: data?.tentative_joining_date,
        rejected_reason: data?.rejected_reason,
        reverting_reason: data?.reverting_reason,
        assignee: { id: data?.assignee_id, display: data?.assignee_name },
        job_designation: data?.job_designation || null,
        job_location: data?.job_location || null,
        mpr_info: mprInfo?.mpr_requests_pk ? {
          ...mprInfo,
          mpr_id: mprInfo?.mpr_requests_pk ,
        } : "",
        replacement_employee_name: (() => {
          let repDetails = [];
          if (typeof mprInfo?.replacement_details === "string") {
            try { repDetails = JSON.parse(mprInfo.replacement_details) || []; } catch (e) {}
          } else if (Array.isArray(mprInfo?.replacement_details)) {
            repDetails = mprInfo.replacement_details;
          }
          if (data?.replacement_employee_name) return data.replacement_employee_name;
          if (mprInfo?.hiring_type === "Replacement" && repDetails?.length > 0) {
            let alreadyReplaced = [];
            if (Array.isArray(mprInfo?.mpr_jobpost_replacement_details)) {
              mprInfo.mpr_jobpost_replacement_details.forEach((rep) => {
                if (rep?.replacement_employee_name && (!data?.candidate_job_id || +rep?.candidate_job_pk !== +data?.candidate_job_id)) {
                  alreadyReplaced.push(rep.replacement_employee_name.trim().toLowerCase());
                }
              });
            }
            const availableOpt = repDetails.find((r) => !alreadyReplaced.includes((r.name || r.full_name || "").trim().toLowerCase())) || repDetails[0];
            return availableOpt?.name || availableOpt?.full_name || "";
          }
          return mprInfo?.replacement_employee_name || "";
        })(),
        replacement_employee_designation: (() => {
          let repDetails = [];
          if (typeof mprInfo?.replacement_details === "string") {
            try { repDetails = JSON.parse(mprInfo.replacement_details) || []; } catch (e) {}
          } else if (Array.isArray(mprInfo?.replacement_details)) {
            repDetails = mprInfo.replacement_details;
          }
          if (data?.replacement_employee_designation) return data.replacement_employee_designation;
          if (mprInfo?.hiring_type === "Replacement" && repDetails?.length > 0) {
            let alreadyReplaced = [];
            if (Array.isArray(mprInfo?.mpr_jobpost_replacement_details)) {
              mprInfo.mpr_jobpost_replacement_details.forEach((rep) => {
                if (rep?.replacement_employee_name && (!data?.candidate_job_id || +rep?.candidate_job_pk !== +data?.candidate_job_id)) {
                  alreadyReplaced.push(rep.replacement_employee_name.trim().toLowerCase());
                }
              });
            }
            const availableOpt = repDetails.find((r) => !alreadyReplaced.includes((r.name || r.full_name || "").trim().toLowerCase())) || repDetails[0];
            return availableOpt?.designation || "";
          }
          return mprInfo?.replacement_employee_designation || "";
        })(),
        replacement_ctc: (() => {
          let repDetails = [];
          if (typeof mprInfo?.replacement_details === "string") {
            try { repDetails = JSON.parse(mprInfo.replacement_details) || []; } catch (e) {}
          } else if (Array.isArray(mprInfo?.replacement_details)) {
            repDetails = mprInfo.replacement_details;
          }
          if (data?.replacement_ctc !== undefined && data?.replacement_ctc !== null && data?.replacement_ctc !== "") return data.replacement_ctc;
          if (mprInfo?.hiring_type === "Replacement" && repDetails?.length > 0) {
            let alreadyReplaced = [];
            if (Array.isArray(mprInfo?.mpr_jobpost_replacement_details)) {
              mprInfo.mpr_jobpost_replacement_details.forEach((rep) => {
                if (rep?.replacement_employee_name && (!data?.candidate_job_id || +rep?.candidate_job_pk !== +data?.candidate_job_id)) {
                  alreadyReplaced.push(rep.replacement_employee_name.trim().toLowerCase());
                }
              });
            }
            const availableOpt = repDetails.find((r) => !alreadyReplaced.includes((r.name || r.full_name || "").trim().toLowerCase())) || repDetails[0];
            return availableOpt?.ctc || "";
          }
          return mprInfo?.replacement_ctc || "";
        })(),
        interview_date: data?.interview_date || null,
      });
    }
    // eslint-disable-next-line
  }, [data])
  const handleClick = () => {
    if (selectedIndex === 1) {
      setOpenPopup(true);
    } else {
      localStorage.setItem("feedbackData", JSON.stringify({ data, userData }));
      const url = "/ats/give-feedback/";
      window.open(url, "_blank");
    }
  };
  const handleApprove = ({type, name, email, approver_status}) => {
    setApproverDetails({type, name, email, approver_status})
    setOpenApprove(true);
  };

  const handleReshare = () => {
    setOpenReshare(true);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };
  const handleClickNotes = () => {
    setOpenNotes(true);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const [isMprLoading, setIsMprLoading] = useState(false);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "3") {
      dispatch(GetOfferLetterTemplateResponseAction({offer_letter_response_id: data?.offer_letter_response_id}))
      setIsMprLoading(true);
      fnGetJobMprHelper({ ats_jobpost_fk: data?.ats_jobpost_id }).then((res) => {
          const mprObj = res?.data.data?.[0]?.fn_get_job_mpr?.[0] || "";
          setJobMprInfo(mprObj)
      }).finally(() => {
          setIsMprLoading(false);
      })
    }
  };

  const validate = (fieldValues) => {
    let temp = { ...errors };
    if ("stage_id" in fieldValues) {
      temp.stage_id = fieldValues?.stage_id === "" ? "Stage is required" : "";
    }
    if ("joined_date" in fieldValues) {
      temp.joined_date =
        fieldValues?.joined_date === "" && data?.job_stage_name === "Joined"
          ? "Join date is required"
          : "";
    }
    if ("tentative_joining_date" in fieldValues) {
      temp.tentative_joining_date =
        fieldValues?.tentative_joining_date === "" &&
          data?.job_stage_name === "Joined"
          ? "Tentative joning date is Required"
          : "";
    }
    if ("rejected_reason" in fieldValues) {
      temp.rejected_reason =
        fieldValues?.rejected_reason === "" ? "Reason is required" : "";
    }
    if ("reverting_reason" in fieldValues) {
      temp.reverting_reason =
        fieldValues?.reverting_reason === "" ? "Revert Reason is required" : "";
    }
    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (event, value) => {
    if (["stage_id"].includes(event)) {
      if (value) {
        if (value.name === "Offer Accepted") {
          setPreviewData({
            ...previewData,
            [event]: value,
            accepted_ctc: "",
            tentative_joining_date: "",
            interview_date: null,
          });
        } else if (value.name === "Offer Released") {
          setPreviewData({
            ...previewData,
            [event]: value,
            offer_released_date: default_date,
            interview_date: null,
          });
        } else if (value.name === "Joined") {
          addSessionData({ key: "popup", value: "false" });
          setPreviewData({
            ...previewData,
            [event]: value,
            joined_ctc: "",
            joined_date: default_date,
            interview_date: null,
          });
        } else if (value.name === "Rejected") {
          setPreviewData({
            ...previewData,
            [event]: value,
            rejected_reason: "",
            interview_date: null,
          });
        } else if (data.job_stage_name === "Rejected") {
          setPreviewData({
            ...previewData,
            [event]: value,
            reverting_reason: "",
            interview_date: null,
          });
        } else {
          setPreviewData({ ...previewData, [event]: value, interview_date: null });
        }
      } else {
        setPreviewData({ ...previewData, [event]: "", interview_date: null });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...previewData, [event]: value ? value : "" });
    } else if (["assignee"].includes(event)) {
      if (value) setPreviewData({ ...previewData, [event]: value });
      else setPreviewData({ ...previewData, [event]: "" });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : "" });
    } else if (event === "mpr_info") {
      if (value) {
        let repDetails = [];
        if (typeof value?.replacement_details === "string") {
          try { repDetails = JSON.parse(value.replacement_details) || []; } catch (e) {}
        } else if (Array.isArray(value?.replacement_details)) {
          repDetails = value.replacement_details;
        }
        let alreadyReplaced = [];
        if (Array.isArray(value?.mpr_jobpost_replacement_details)) {
          value.mpr_jobpost_replacement_details.forEach((rep) => {
            if (rep?.replacement_employee_name && (!data?.candidate_job_id || +rep?.candidate_job_pk !== +data?.candidate_job_id)) {
              alreadyReplaced.push(rep.replacement_employee_name.trim().toLowerCase());
            }
          });
        }
        let autoName = "";
        let autoDesignation = "";
        let autoCtc = "";
        if (value?.hiring_type === "Replacement" && repDetails?.length > 0) {
          const availableOpt = repDetails.find((r) => !alreadyReplaced.includes((r.name || r.full_name || "").trim().toLowerCase())) || repDetails[0];
          autoName = availableOpt?.name || availableOpt?.full_name || "";
          autoDesignation = availableOpt?.designation || "";
          autoCtc = availableOpt?.ctc || "";
        }
        setPreviewData({
          ...previewData,
          mpr_info: value,
          ...(value?.hiring_type === "Replacement" ? {
            replacement_employee_name: autoName,
            replacement_employee_designation: autoDesignation,
            replacement_ctc: autoCtc,
          } : {}),
        });
      } else {
        setPreviewData({ ...previewData, mpr_info: "", replacement_employee_name: "", replacement_employee_designation: "", replacement_ctc: "" });
      }
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : "" });
    } else if (event === "replacement_employee_fk") {
      let matchedCtc = previewData?.replacement_ctc || "";
      let repDetails = [];
      if (typeof previewData?.mpr_info?.replacement_details === "string") {
        try { repDetails = JSON.parse(previewData.mpr_info.replacement_details) || []; } catch (e) {}
      } else if (Array.isArray(previewData?.mpr_info?.replacement_details)) {
        repDetails = previewData.mpr_info.replacement_details;
      }
      if (value && repDetails?.length > 0) {
        const match = repDetails.find((r) => +r.candidate_id === +value?.candidate_id);
        if (match && match.ctc !== undefined && match.ctc !== null) {
          matchedCtc = match.ctc;
        }
      }
      setPreviewData({
        ...previewData,
        replacement_employee_fk: value || "",
        replacement_ctc: matchedCtc,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ [event]: value ? value : "" });
    } else if (["ats_status_id"].includes(event)) {
      if (value) {
        if (value?.id === null) {
          AddAtsJobStatusHelper({ name: value?.name }).then((res) => {
            setStatusData({ load: false, values: res?.data?.data });
            setPreviewData({
              ...previewData,
              ats_status_id: res?.data?.data?.filter(
                (resp) => resp?.name === value?.name
              )?.[0],
            });
          });
        } else setPreviewData({ ...previewData, [event]: value });
      }
    } else {
      setPreviewData({
        ...previewData,
        [event.target.name]: event?.target?.value,
      });
      Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
        validate({ ...previewData, [event.target.name]: event?.target?.value });
    }
  };

  const updateKanban = (kanbanData, stageName, comment) => {
    if (data?.offer_letter) {
      UpdateAtsJobKanbanOfferHelper({
        kanban_data: kanbanData,
      }).then((res) => {
        res?.data?.data && setElements(res?.data?.data);
        setCurrentData(res?.data?.data?.find((x) => x?.candidate_job_id === data?.candidate_job_id));
        GetAtsCandidateJobHistoryHelper({
          candidate_job_id: data?.candidate_job_id,
        }).then((resp) => {
          setHistoryData(resp?.data?.data?.[0]?.candidatejob);
        });
        if (stageName === "Joined") {
          if (data?.access_onboard_candidate && !data?.is_onboarded && tabValue === "1") {
            setIsOnboard(true);

          }
        } else if (stageName === "Offer Preparation") {
          if (!data?.offer_preparation_flag) {
            setIsOffer(true);
          }
        }
      });
    } else {
      UpdateAtsJobKanbanHelper({
        kanban_data: kanbanData,
        comment: comment
      }).then((res) => {
        res?.data?.data && setElements(res?.data?.data);
        setCurrentData(res?.data?.data?.find((x) => x?.candidate_job_id === data?.candidate_job_id));
        GetAtsCandidateJobHistoryHelper({
          candidate_job_id: data?.candidate_job_id,
        }).then((resp) => {
          setHistoryData(resp?.data?.data?.[0]?.candidatejob);
        });
        if (stageName === "Joined") {
          if (data?.access_onboard_candidate && !data?.is_onboarded && tabValue === "1") {
            setIsOnboard(true);

          }
        }
      });
    }
  };

  const preparePayloadsValue = () => {
    let mystr = mentionValue.substring(1);
    var arry = mystr.split(" @");
    let ids = [];
    var returnArr = [];
    var finalValue = mentionValue;
    if (arry.some(a => a.includes('[') && a.includes(']') && a.includes('(') && a.includes(')'))) {
      for (var a of arry) {
        var obj = {};
        var value = a.substring(a.lastIndexOf("[") + 1, a.lastIndexOf("]"));
        var key = a.substring(a.lastIndexOf("(") + 1, a.lastIndexOf(")"));
        obj[`firstName`] = value;
        obj[`id`] = key;
        ids.push(`(${key})`);
        returnArr.push(obj);
      }
    }
    const unique = [
      ...new Map(returnArr.map((item) => [item["id"], item])).values(),
    ];
    ids?.forEach((dat) => {
      finalValue = finalValue.replace(dat, "");
    });
    finalValue = finalValue.replace(/\[|\]/g, "").replace("@", "");
    return { unique, finalValue }
  }

  const handleNotificationSend = (finalValue, unique) => {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const today = year + '-' + month.toString().padStart(2, '0') + '-' + day;

    if (unique?.length > 0) {
      let value = [];
      unique?.forEach((res) => {
        if (res?.id !== "") {
          value.push({
            user_id: +res?.id,
            comment: `You were noted by ${userData?.user_name} in ${data?.title} Job. ${finalValue}`,
            is_read: "N",
          });
        }
      });
      AddNotificationHelper({ notification_data: JSON.stringify(value) });
      dispatch(AddAssignedTaskAction({
        assigned_to: `{${value?.map(row => row.user_id)}}`,
        task: value?.[0]?.comment,
        title: `Job Title - ${data?.title}`,
        status: "Yet to Start",
        due_date: today,
        priority: "Medium",
      }))
    }
  }

  const handleSubmit = (notification) => {
    if (validate(previewData)) {
      let { finalValue, unique } = preparePayloadsValue()
      let isJoinedStage = previewData?.stage_id?.name === "Joined";

      updateKanban(
        JSON.stringify([
          {
            proposed_by: data?.proposed_by,
            candidate_job_id: data?.candidate_job_id,
            ats_jobpost_id: data?.ats_jobpost_id,
            interview_feedback: finalValue,
            ats_job_stages_id: previewData?.stage_id?.ats_job_stages_id,
            priority: previewData?.priority,
            ats_status_id: previewData?.ats_status_id?.ats_status_id || null,
            selected: null,
            candidate_id: data?.candidate_id,
            accepted_ctc: previewData?.accepted_ctc || data?.accepted_ctc || 0,
            tentative_joining_date: previewData?.tentative_joining_date || data?.tentative_joining_date || null,
            joined_ctc: previewData?.joined_ctc ? previewData?.joined_ctc : 0,
            joined_date:
              previewData?.stage_id?.name === "Joined" &&
                (!previewData?.joined_date || previewData?.joined_date === "")
                ? default_date
                : previewData?.joined_date || null,
            offer_released_date:
              previewData?.stage_id?.name === "Offer Released" &&
                (!previewData?.offer_released_date ||
                  previewData?.offer_released_date === "")
                ? default_date
                : previewData?.offer_released_date || data?.offer_released_date || default_date,
            rejected_reason: previewData?.rejected_reason || data?.rejected_reason || null,
            assignee_id: Number(previewData?.assignee?.id),
            reverting_reason: previewData?.reverting_reason || data?.revert_reason || null,
            job_designation: previewData?.job_designation || null,
            job_location: previewData?.job_location || null,
            mpr_requests_fk: isJoinedStage ? previewData?.mpr_info?.mpr_id || null : null,
            replacement_employee_name: isJoinedStage ? previewData?.replacement_employee_name || null : null,
            replacement_employee_designation: isJoinedStage ? previewData?.replacement_employee_designation || null : null,
            replacement_ctc: isJoinedStage ? previewData?.replacement_ctc || null : null,
            primary_approver_status: data?.primary_approver_status,
            secondary_approver_status: data?.secondary_approver_status,
            interview_date: previewData?.interview_date || null,
          },
        ]),
        previewData?.stage_id?.name,
        notification
      );
      if (notification === "YES") {
        handleNotificationSend(finalValue, unique);
      };
      setMentionValue("");
      setErrors({});
    }
  };
  const handleStatusData = () => {
    GetAtsJobStatusHelper().then((res) =>
      setStatusData({ load: false, values: res?.data?.data || [] })
    );
  };
  const handleClickPreview = () => {
    toggleDrawer(false);
    setCandidatePreview(true);
    setCandidateUpdate(false);
  };
  const handleChange = (e, id) => {
    setMentionValue(e.target.value);
  };
  const handleOnboarding = () => {
    setOpenPopup(false);
    dispatch(EnableAddRequestAction({ mode: "add", data: data }));
    addSessionData({ key: "selectedMenu", value: "Employee Onboarding" });
    dispatch(AddMenuHeadingAction({ heading: "Employee Onboarding" }));
    history.push("/onboarding");
  };
  const handleViewFeedback = (res_id) => {
    const resId = res_id;
    let pre_screen_token = resId + `=${userData?.domain}`;
    const url = `/ats/feedback-responses/${btoa(pre_screen_token)}`;
    window.open(url, "_blank");
  };
  const handleSend = () => {
    PreScreenCandidateEmailHelper({
      jobData: currentJobData,
      kanban_data: data,
    });
    setOpenPreScreen(false);
  };
  const handlePreScreen = () => {
    setOpenPreScreen(true);
  };
  // check the score are available or need to generate
  const isMissing = (v) => v === null || v === undefined || v === "";
  const shouldGenerateScore = isMissing(data?.prescreen_textual_score) && isMissing(data?.prescreen_video_score);
  const handleResponseScreen = () => {
    if (isAiJob) {
      if (showResponse) {
        prescreenRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        setShowResponse(true);
        // generate PreScreening Score at the run time if not exist
        if (shouldGenerateScore) {
          handleGenerateScreeningScore();
        }
      }
    } else {
      const resId = data?.f_prescreen_response_fk;
      let pre_screen_token = resId + `=${userData?.domain}`;
      const url = `/ats/prescreen-responses/${btoa(pre_screen_token)}`;
      window.open(url, "_blank");
    }
  };
  const handleViewOffer = () => {
    setIsOfferView(true);
  };
  const handleEdit = () => {
    setOpenEditOfferAlert(true);
  };

  const handleStages = () => {
    let filteredData = stageData;

    if (currentJobData?.offer_letter) {
      if (
        data?.job_stage_name === "Offer Preparation" &&
        !data?.offer_preparation_completed
      ) {
        // If in "Offer Preparation" stage and not completed, load all stages
        const excludedStages = ["6", "7", "8", "9"];
        filteredData = stageData.filter((stage) => {
          return !excludedStages.includes(stage.sort_key);
        });
      } else if (
        data?.job_stage_name === "Offer Preparation" ||
        data?.job_stage_name === "Offer Released" ||
        data?.job_stage_name === "Offer Rejected" ||
        data?.job_stage_name === "Offer Accepted" ||
        data?.job_stage_name === "Joined"
      ) {
        // Load all stages without exclusion
        filteredData = stageData;
      } else {
        // Exclude stages with sort_key "6", "7", "8", "9"
        const excludedStages = ["6", "7", "8", "9"];
        filteredData = stageData.filter((stage) => {
          return !excludedStages.includes(stage.sort_key);
        });
      }
    }

    setStagesData({ load: false, values: filteredData });
  };
  useEffect(() => {
    if (showResponse) {
      prescreenRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [showResponse]);
  // generate AI Candidate Screening Score
  const handleGenerateScreeningScore = () => {
    if (aiConfigPopupRef.current) {
      aiConfigPopupRef.current.validateAIConfig().then((res) => {
        if (res.ok) {
          dispatch(
            GetAtsPythonPreScreenScoreAction(
              { candidate_job_id: [data?.candidate_job_id] },
              (error, result) => {
                if (!error && result) {
                  getKanbanData();
                  toast.success("Screening score generated successfully");
                } else {
                  toast.error("Something went wrong");
                }
              },
            ),
          );
        }
      });
    }
  };
  const [mprData, setMprData] = useState({
      load: true,
      values: [],
    });
 
  const handleMPROption = () => {
    fnGetAvailableJobMprHelper({ ats_jobpost_fk: data?.ats_jobpost_id }).then((res) => {
      if (res?.data?.statuscode === 200) {
        const rawMprList = res?.data?.data?.[0]?.fn_get_available_job_mpr || [];
        const formattedList = rawMprList.map((item) => ({
          ...item,
          mpr_display: item?.hiring_type ? `${item.mpr_no} - ${item.hiring_type}` : item.mpr_no,
        }));
        setMprData({ load: false, values: formattedList });
      } else {
        setMprData({ load: false, values: [] });
      }
    })
  }

const primaryApprover = jobMprInfo?.approver_name;
const secondApprover = jobMprInfo?.second_approver_name;
const candidateCtc = offerData?.payconfig_input_json?.grossEarningsTempTotalValue || 0;
const isMprMapped = Boolean(jobMprInfo?.mpr_id) && jobMprInfo?.is_budgeted && jobMprInfo?.max_salary // budgeted + max_salary is available
const maxSalary = isMprMapped ? (jobMprInfo?.max_salary || 0) : (currentJobData?.max_salary || 0);
const isAboveBudget = Number(maxSalary) > 0 && offerData?.is_configure_ctc && Number(candidateCtc) > Number(maxSalary);

const primaryApprovalStatus = data?.primary_approver_status || "Pending";
const secondApprovalStatus = data?.secondary_approver_status || "Pending";
// const primaryApprovalStatus = rawPrimaryStatus;
// const secondApprovalStatus = !isAboveBudget
//   ? "Not Required" : rawPrimaryStatus === "Approved" 
//   ? rawSecondaryStatus : rawPrimaryStatus === "Rejected" ? "Not Required" : "Not Required";

const isOfferCompleted = data?.offer_preparation_completed;
const isCloudPathAval = offerData?.offer_letter_cloud_path;
const managerApproval = data?.managers_approval;
const primaryApprovalDisabled =  primaryApprovalStatus === "Approved"
const secondaryApprovalDisabled = managerApproval && secondApprovalStatus === "Approved"

const isOfferPreparation = data?.job_stage_name === "Offer Preparation";
const isOfferReleased = data?.job_stage_name === "Offer Released";
const isOfferRejected = data?.job_stage_name === "Offer Rejected";
const isOfferAccepted = data?.job_stage_name === "Offer Accepted";
const isJoined = data?.job_stage_name === "Joined";
const isOfferStages = isOfferPreparation || isOfferReleased || isOfferRejected || isOfferAccepted || isJoined
  return (
    <>
      <Popup
        fullWidth={true}
        maxWidth="md"
        title="Request Feedback"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <RequestFeedback data={data} setOpenPopup={setOpenPopup} />
      </Popup>
      <Popup
        fullWidth={true}
        maxWidth="md"
        title="Request for Offer Letter Approval"
        openPopup={openapprove}
        setOpenPopup={() => {setOpenApprove(false); setApproverDetails("")}}
      >
        <SendApprovalOfferLetter
          currentJobData={currentJobData}
          data={data}
          setOpenPopup={() => {setOpenApprove(false); setApproverDetails("")}}
          setElements={setElements}
          approverDetails={{...approverDetails, is_above_budget: isAboveBudget}}
        />
      </Popup>
      <Popup
        fullWidth={true}
        maxWidth="md"
        title="Send Offer Letter"
        openPopup={openreshare}
        setOpenPopup={setOpenReshare}
      >
        <SendReshareOfferLetter
          currentData={data}
          setOpenPopup={setOpenReshare}
          currentJobData={currentJobData}
          setElements={setElements}
        />
      </Popup>

      <Box sx={{ padding: "0px 10px 10px 10px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0px 8px 8px 16px",
          }}
        >
          <div sx={{ display: "flex", flexDirection: "row" }}>
            <Typography variant="h5">
              {data?.full_name || data?.first_name}
            </Typography>
          </div>
          <div>
            {data?.linkedin_profile !== null &&
              data?.linkedin_profile !== "" && (
                <a
                  style={{
                    pointerEvents: data?.linkedin_profile ? "auto" : "none",
                  }}
                  href={data?.linkedin_profile}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <IconButton>
                    <Tooltip title="LinkedIn Profile">
                      <LinkedInIcon fontSize="small" />
                    </Tooltip>
                  </IconButton>
                </a>
              )}
            <IconButton>
              <Tooltip title="Notes">
                <CommentRoundedIcon
                  onClick={handleClickNotes}
                  sx={{
                    cursor: "pointer",
                    color: theme?.palette?.primary?.main,
                  }}
                  fontSize="small"
                />
              </Tooltip>
            </IconButton>
            <IconButton onClick={handleClickPreview}>
              <Tooltip title="Preview and edit candidate details">
                <EditIcon fontSize="small" />
              </Tooltip>
            </IconButton>
            <IconButton onClick={() => toggleDrawer(false)}>
              <Tooltip title="Close">
                <CloseIcon fontSize="small" />
              </Tooltip>
            </IconButton>
          </div>
        </Box>
        <Divider />
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 20px 10px 20px",
              flex: "0 0 60%",
              height: isAiJob ? "505px" : "450px",
              overflowY: "auto",
            }}
          >
            <Typography variant="h5">{data?.name}</Typography>

            <div className={classes.row}>
              <span className={classes.label}>Contact</span>: &nbsp;
              <div className={classes.value}> {data?.contact_no}</div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Email</span>: &nbsp;
              <div className={classes.value}> {data?.email_id}</div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Designation</span>: &nbsp; &nbsp;
              <div className={classes.value}>{data?.designation}</div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Date of Birth</span>: &nbsp; 
              <div className={classes.value}>{data?.dob}</div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Gender</span>: &nbsp; 
              <div className={classes.value}>{data?.gender}</div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Year of Experience</span> : &nbsp; 
              <div className={classes.value}>
               {data?.years_of_experience}
              </div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Primary Skills</span>: &nbsp;
              <div className={classes.value}>
                {data?.primary_skill ? (
                  data?.primary_skill.split(",")?.map((row) => {
                    return (
                      <Chip
                        label={row}
                        variant="outlined"
                        sx={{
                          mr: 2,
                          mb: 1,
                          fontSize: "1 rem",
                        }}
                      />
                    );
                  })
                ) : (
                  <Typography variant="span" sx={{ fontSize: "1.7rem" }}>
                    -
                  </Typography>
                )}
              </div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Secondary Skills</span>: &nbsp; 
              <div className={classes.value}>
                {data?.secondary_skill}
              </div>
            </div>

            <div className={classes.row}>
              <span className={classes.label}>Current CTC</span>: &nbsp; 
              <div className={classes.value}>{data?.current_ctc}</div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Expected Pay</span>: &nbsp; 
              <div className={classes.value}>{data?.expected_pay}</div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Current Employer</span>: &nbsp; 
              <div className={classes.value}>
                {data?.current_employer}
              </div>
            </div>
            <div className={classes.row}>
              <span className={classes.label}>Notice Period</span>: &nbsp; 
              <div className={classes.value}>
                {data?.notice_period}
              </div>
            </div>
            {data?.resume && (
              <div className={classes.row}>
                <span className={classes.label}>Resume</span>: &nbsp;
                <div
                  className={classes.value}
                  onClick={() => DownloadAttachment(data?.resume)}
                  style={{ cursor: "pointer" }}
                >
                  <DescriptionIcon />{" "}
                  <Typography pl={1}>
                    {data?.first_name || ""}_{APP_NAME}.
                    {data?.resume.split(".").at(-1)}
                  </Typography>
                </div>
              </div>
            )}

            {/* has_prescreen_response */}
            <div className={classes.row}>
              <span className={classes.label}> {isAiJob ? "Screening Assessment" : "Pre Screen Question"}</span> : &nbsp;
              <div className={classes.value}>
                {data?.f_prescreen_response_fk === "0" ? (
                  <Tooltip
                    title={
                      !currentJobData?.prescreen_template_id
                        ? "Please set pre-screen template for this job first"
                        : ""
                    }
                  >
                    <button
                      disabled={!currentJobData?.prescreen_template_id}
                      onClick={handlePreScreen}
                      className={
                        !currentJobData?.prescreen_template_id
                          ? "cta-disable"
                          : "cta"
                      }
                    >
                      <span className="hover-underline-animation">
                        Collect Response
                      </span>
                      <svg
                        id="arrow-horizontal"
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="10"
                        viewBox="0 0 46 16"
                      >
                        <path
                          id="Path_10"
                          data-name="Path 10"
                          fill={
                            !currentJobData?.prescreen_template_id
                              ? "#d3d3d3"
                              : "#883bd5"
                          }
                          d="M8,0,6.545,1.455l5.506,5.506H-30V9.039H12.052L6.545,14.545,8,16l8-8Z"
                          transform="translate(30)"
                        ></path>
                      </svg>
                    </button>
                  </Tooltip>
                ) : (
                  <button onClick={handleResponseScreen} className="cta">
                    <span className="hover-underline-animation">
                      {isAiJob ? "View Screening AI Score" : "View Response"}
                    </span>
                    <svg
                      id="arrow-horizontal"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="10"
                      viewBox="0 0 46 16"
                    >
                      <path
                        id="Path_10"
                        data-name="Path 10"
                        fill="#883bd5"
                        d="M8,0,6.545,1.455l5.506,5.506H-30V9.039H12.052L6.545,14.545,8,16l8-8Z"
                        transform="translate(30)"
                      ></path>
                    </svg>
                  </button>
                )}
              </div>
            </div>
            {data?.offer_letter_cloud_path && (
              <div className={classes.row}>
                <span className={classes.label}>Offer Letter</span>
                <div
                  className={classes.value}
                  onClick={() =>
                    DownloadAttachment(data?.offer_letter_cloud_path, `${data?.first_name}_Offer_Letter.${data?.offer_letter_cloud_path.split(".").at(-1)}`)
                  }
                  style={{ cursor: "pointer" }}
                >
                  : &nbsp;
                  <DescriptionIcon />{" "}
                  <Typography pl={1}>
                    {data?.first_name || ""}_Offer_Letter.
                    {data?.offer_letter_cloud_path.split(".").at(-1)}
                  </Typography>
                </div>
              </div>
            )}
            <Divider orientation="horizontal" />
            <TabContext value={value}>
              <Box>
                <TabList
                  sx={{
                    minHeight: "40px",
                    ".MuiTab-root": { minHeight: "20px" },
                    "& .MuiTabs-indicator": {
                      width: "100%",
                      display: "flex",
                      justifyContent: "center !important",
                    },
                     mb: -2
                  }}
                  onChange={handleTabChange}
                  aria-label="lab API tabs example"
                >
                  <Tab label="History" value="1" />
                  <Tab label="Feedback" value="2" />
                  {data?.offer_letter && isOfferStages && (
                    isOfferCompleted ? (
                      <Tab
                        label="Offer Details"
                        value="3"
                      />
                    ) : (
                      <Tooltip
                        title="Please complete the Offer generation before accessing Offer Details."
                        arrow
                      >
                        <span>
                          <Tab
                            label="Offer Details"
                            value="3"
                            disabled
                          />
                        </span>
                      </Tooltip>
                    )
                  )}
                </TabList>
              </Box>
              <TabPanel value="1">
                {historyData?.map((hist, index) => {
                  let date = new Date(hist?.modifiedon);
                  date.setHours(date.getHours() + 5);
                  date.setMinutes(date.getMinutes() + 30);
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        padding: "10px 10px",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Avatar
                          name={`${hist?.requester_name || hist?.modifiedby || ""}`}
                          round="50%"
                          size="30"
                          style={{
                            padding: "0px",
                            fontSize: "10px",
                            marginBottom: 2,
                          }}
                        />
                        <div>
                          <Typography sx={{ paddingLeft: 2 }} variant="body1">
                            <span style={{ fontWeight: 600 }}>
                              {hist?.requester_name || hist?.modifiedby}
                            </span>{" "}
                            {hist?.modifiedon && (
                              <TimeAgo
                                timeStyle="round"
                                date={date}
                                locale="en-US"
                              />
                            )}
                          </Typography>
                          {hist?.is_feedback_record && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              <span style={{ fontWeight: 600 }}>
                                {hist?.modifiedby}
                              </span>{" "}
                              has requested feedback from{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.responder_name}
                              </span>
                            </Typography>
                          )}
                          {hist?.ats_job_stages !== hist?.previous_stage_id &&
                            !hist?.is_feedback_record &&
                            !hist?.requester_name && (
                              <Typography sx={{ paddingLeft: 2 }} variant="body2">
                                Changed the stage{" "}
                                <span style={{ fontWeight: 600 }}>
                                  {hist?.previous_stage_id === "" ||
                                    hist?.previous_stage_id === null
                                    ? "Candidate Proposed"
                                    : `${hist?.previous_stage_id || "None"} → ${hist?.ats_job_stages || "None"
                                    }`}
                                </span>
                              </Typography>
                            )}
                          {hist?.priority !== hist?.previous_priority && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              Changed the priority{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.previous_priority || "None"} →{" "}
                                {hist?.priority || "None"}
                              </span>
                            </Typography>
                          )}
                          {hist?.status !== hist?.previous_status && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              Changed the status{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.previous_status || "None"} →{" "}
                                {hist?.status || "None"}
                              </span>
                            </Typography>
                          )}
                          {hist?.rejected_reason !==
                            hist?.previous_rejected_reason && (
                              <Typography sx={{ paddingLeft: 2 }} variant="body2">
                                Candidate rejected reason{" "}
                                <span style={{ fontWeight: 600 }}>
                                  {hist?.previous_rejected_reason || "None"} →{" "}
                                  {hist?.rejected_reason || "None"}
                                </span>
                              </Typography>
                            )}
                          {hist?.reverting_reason !==
                            hist?.previous_reverting_reason && (
                              <Typography sx={{ paddingLeft: 2 }} variant="body2">
                                Candidate revert reason{" "}
                                <span style={{ fontWeight: 600 }}>
                                  {hist?.previous_reverting_reason || "None"} →{" "}
                                  {hist?.reverting_reason || "None"}
                                </span>
                              </Typography>
                            )}
                          {hist?.selected !== hist?.previous_selected &&
                            hist?.selected === "True" && (
                              <Typography sx={{ paddingLeft: 2 }} variant="body2">
                                Candidate got{" "}
                                <span style={{ fontWeight: 600 }}>Selected</span>
                              </Typography>
                            )}
                          {hist?.selected !== hist?.previous_selected &&
                            hist?.selected === "False" && (
                              <Typography sx={{ paddingLeft: 2 }} variant="body2">
                                Candidate got{" "}
                                <span style={{ fontWeight: 600 }}>Unselected </span>
                              </Typography>
                            )}
                          {hist?.comment && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              Added comment{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.comment}
                              </span>
                            </Typography>
                          )}
                          {hist?.interview_feedback && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              Added feedback{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.interview_feedback}
                              </span>
                              {hist?.requester_name !== null &&
                                hist?.responder_name !== null && (
                                  <span style={{ fontWeight: 600 }}>
                                    {" "}
                                    and eligibility{" "}
                                    {hist?.is_eligible ? "Yes" : "No"}
                                  </span>
                                )}
                              <br />
                              {hist?.feedback_proof_name !== null && (
                                <Typography
                                  sx={{ color: "#1155cc", cursor: "pointer" }}
                                  onClick={() =>
                                    DownloadAttachment(hist.feedback_proof_name)
                                  }
                                >
                                  Feedback Document
                                </Typography>
                              )}
                            </Typography>
                          )}
                          {hist?.feedback_response_id && (
                            <>
                              <Typography sx={{ paddingLeft: 2 }} variant="body2">
                                Added feedback{" "}
                                <span style={{ fontWeight: 600 }}>
                                  {hist?.interview_feedback}
                                </span>
                                {hist?.requester_name !== null &&
                                  hist?.responder_name !== null && (
                                    <span style={{ fontWeight: 600 }}> </span>
                                  )}
                                <br />
                                {hist?.feedback_proof_name !== null && (
                                  <Typography
                                    sx={{ color: "#1155cc", cursor: "pointer" }}
                                    onClick={() =>
                                      DownloadAttachment(hist.feedback_proof_name)
                                    }
                                  >
                                    Feedback Document
                                  </Typography>
                                )}
                              </Typography>
                              <Box
                                sx={{ paddingLeft: 2 }}
                                onClick={() =>
                                  handleViewFeedback(hist?.feedback_response_id)
                                }
                              >
                                <Typography
                                  sx={{
                                    color: "blue",
                                    textDecoration: "none",
                                    "&:hover": {
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    },
                                  }}
                                >
                                  View Feedback
                                </Typography>
                              </Box>
                            </>
                          )}
                          {hist?.tentative_joining_date && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              <span style={{ fontWeight: 600 }}>
                                {hist?.modifiedby}
                              </span>{" "}
                              Added tentative joining date as{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.tentative_joining_date}
                              </span>
                            </Typography>
                          )}

                          {hist?.offer_released_date && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              <span style={{ fontWeight: 600 }}>
                                {hist?.modifiedby}
                              </span>{" "}
                              added released date as{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.offer_released_date}
                              </span>
                            </Typography>
                          )}
                          {hist?.joined_date && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              <span style={{ fontWeight: 600 }}>
                                {hist?.modifiedby}
                              </span>{" "}
                              added joined date as{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.joined_date}
                              </span>
                            </Typography>
                          )}
                          {hist?.assignee !== hist?.previous_assignee && (
                            <Typography sx={{ paddingLeft: 2 }} variant="body2">
                              Changed the assignee{" "}
                              <span style={{ fontWeight: 600 }}>
                                {hist?.previous_assignee || "None"} →{" "}
                                {hist?.assignee || "None"}
                              </span>
                            </Typography>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </TabPanel>
              <TabPanel value="2">
                <TableContainer component={Paper} sx={{ width: "92%" }} >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow
                        sx={{
                          "& th": {
                            bgcolor: "",
                            fontWeight: "bold",
                            textAlign: "center",
                            padding: "5px 0px",
                            fontSize: "14px"
                          },
                        }}
                      >
                        <TableCell>Submitted by</TableCell>
                        <TableCell>Submitted on</TableCell>
                        <TableCell>Feedback</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historyData
                        ?.filter((hist) => hist?.feedback_response_id)
                        ?.map((hist, index) => {
                          let date = new Date(hist?.modifiedon);
                          date.setHours(date.getHours() + 5);
                          date.setMinutes(date.getMinutes() + 30);
                          return (
                            <TableRow
                              key={index}
                              sx={{
                                "& td": { textAlign: "center", padding: "5px 0px", fontSize: "14px" },
                              }}
                            >
                              <TableCell>{hist?.responder_name}</TableCell>
                              <TableCell>
                                {hist?.modifiedon && (
                                  <TimeAgo
                                    timeStyle="round"
                                    date={date}
                                    locale="en-US"
                                  />
                                )}
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{ paddingLeft: 2 }}
                                  onClick={() =>
                                    handleViewFeedback(
                                      hist?.feedback_response_id
                                    )
                                  }
                                >
                                  <Typography
                                    sx={{
                                      color: "blue",
                                      textDecoration: "none",
                                      fontSize: "0.75rem",
                                      "&:hover": {
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      },
                                    }}
                                  >
                                    View Feedback
                                  </Typography>
                                </Box>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>  
              {/* data?.offer_letter */}

                <TabPanel value="3">
                  <Box
                    sx={{

                      border: "1px solid #e5e7eb",
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        px: 1.5,
                        py: 1.2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "15px",
                            fontWeight: 600,
                            color: "#27364b",
                          }}
                        >
                          Offer Approval
                        </Typography>
                      
                        <Tooltip
                          title={


                              
                              

                            <ul style={{ margin: 0, paddingLeft: 16, fontSize: 11, fontWeight: "normal" }}>
                              <li>
                                {offerData?.is_configure_ctc === false
                                  ? "CTC is not configured for this candidate. You can edit the offer letter if needed."
                                  : "CTC is configured for this candidate."}
                              </li>
                              {offerData?.is_configure_ctc !== false && (
                                <>
                                  <li>
                                    If the MPR is budgeted, the candidate CTC is compared with the MPR max salary. Otherwise, the Job's max salary is used.
                                  </li>
                                  <li>
                                    If the candidate CTC exceeds the applicable limit, secondary approval is required after primary approval. If neither limit is available, secondary approval is not required.
                                  </li>
                                </>
                              )}
                            </ul>

                          }
                          placement="top"
                          arrow
                        >
                          <InfoOutlinedIcon
                            sx={{
                              fontSize: "16px",
                              color: "#64748b",
                              cursor: "pointer",
                            }}
                          />
                        </Tooltip>
                      </Box>

                      <Box sx={{ display: "flex", gap: 0.7 }}>
                        {isOfferStages && (
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={!isOfferCompleted}
                            onClick={handleViewOffer}
                            sx={{
                              minWidth: "auto",
                              px: 1,
                              py: 0.45,
                              fontSize: "10px",
                              textTransform: "none",
                              borderRadius: "5px",
                            }}
                          >
                            View Offer
                          </Button>
                        )}

                        {isOfferPreparation && !managerApproval && (
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={!isOfferCompleted}
                            onClick={handleEdit}
                            sx={{
                              minWidth: "auto",
                              px: 1,
                              py: 0.45,
                              fontSize: "10px",
                              textTransform: "none",
                              borderRadius: "5px",
                            }}
                          >
                            Edit Offer
                          </Button>
                        )}

                        {((isOfferPreparation && managerApproval && isCloudPathAval) || isOfferReleased ||
                          isOfferRejected ||
                          isOfferAccepted ||
                          isJoined) && (
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={handleReshare}
                            sx={{
                              minWidth: "auto",
                              px: 1,
                              py: 0.45,
                              fontSize: "10px",
                              textTransform: "none",
                              borderRadius: "5px",
                            }}
                          >
                            Send Offer
                          </Button>
                        )}
                      </Box>
                    </Box>

                    {isMprLoading || isOfferLetterResponseLoading ? (
                      <Skeleton
                        variant="rectangular"
                        height={100}
                        sx={{
                          mx: 1.5,
                          mt: 1.2,
                          borderRadius: "8px",
                        }}
                      />
                    ) : offerData?.is_configure_ctc === false ? null : (
                      <Box
                        sx={{
                          mx: 1.5,
                          mt: 1.2,
                          p: 1.2,
                          borderRadius: "8px",
                          backgroundColor: "#f8f9fc",
                          border: "1px solid #eef0f4",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 600,
                            color: "#667085",
                            mb: 0.8,
                          }}
                        >
                          CTC Details
                        </Typography>

                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 1,
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{
                                fontSize: "9px",
                                color: "#98a2b3",
                              }}
                            >
                              Candidate CTC
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#344054",
                                mt: 0.2,
                              }}
                            >
                              {candidateCtc || 0}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              sx={{
                                fontSize: "9px",
                                color: "#98a2b3",
                              }}
                            >
                              {isMprMapped ? "MPR Max Salary Budget" : "Job Max Salary Budget"}
                            </Typography>

                            <Typography
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#344054",
                                mt: 0.2,
                              }}
                            >
                              {maxSalary}
                            </Typography>
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            mt: 1,
                            pt: 0.8,
                            borderTop: "1px solid #e5e7eb",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "10px",
                              color: "#667085",
                            }}
                          >
                            Budget Status
                          </Typography>

                          <BudgetStatusChip
                            candidateCtc={candidateCtc}
                            budget={maxSalary}
                          />
                        </Box>
                      </Box>
                    )}

                    {/* APPROVAL PIPELINE */}
                    {isMprLoading || isOfferLetterResponseLoading ? (
                      <Skeleton
                        variant="rectangular"
                        height={140}
                        sx={{
                          mx: 1.5,
                          my: 1.5,
                          borderRadius: "8px",
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          px: 1.5,
                          py: 1.5,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 600,
                            color: "#667085",
                            mb: 1.3,
                          }}
                        >
                          Approval Workflow
                        </Typography>

                        <Box
                          sx={{
                            position: "relative",
                            pl: 3.5,
                          }}
                        >
                          <Box
                            sx={{
                              position: "absolute",
                              left: "9px",
                              top: "12px",
                              bottom: "12px",
                              width: "2px",
                              backgroundColor: "#e5e7eb",
                            }}
                          />

                          {/*PRIMARY*/}
                          <Box
                            sx={{
                              position: "relative",
                              pb: 2,
                            }}
                          >
                            <Box
                              sx={{
                                position: "absolute",
                                left: "-29px",
                                top: 1,
                                width: 20,
                                height: 20,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor:
                                  primaryApprovalStatus === "Approved"
                                    ? "#16a34a"
                                    : "#f59e0b",
                                color: "#fff",
                                fontSize: "10px",
                                fontWeight: 700,
                                zIndex: 1,
                              }}
                            >
                              {primaryApprovalStatus === "Approved" ? "✓" : "1"}
                            </Box>

                            <Box
                              sx={{
                                border: "1px solid #e5e7eb",
                                borderRadius: "8px",
                                p: 1.1,
                                backgroundColor:
                                  primaryApprovalStatus === "Approved"
                                    ? "#fbfffc"
                                    : "#fffdf7",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  justifyContent: "space-between",
                                  gap: 1,
                                }}
                              >
                                <Box sx={{ minWidth: 0 }}>
                                  <Typography
                                    sx={{
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      color: "#344054",
                                    }}
                                  >
                                    Primary Approval
                                  </Typography>

                                  <Typography
                                    sx={{
                                      fontSize: "10px",
                                      color: "#667085",
                                      mt: 0.3,
                                    }}
                                  >
                                    {primaryApprover || "-"}
                                  </Typography>
                                </Box>

                                {(() => {
                                  const { bg, text } = getStatusColor(primaryApprovalStatus);
                                  return (
                                    <Chip
                                      label={primaryApprovalStatus}
                                      size="small"
                                      sx={{
                                        height: 21,
                                        fontSize: "9px",
                                        fontWeight: 600,
                                        backgroundColor: bg,
                                        color: text,
                                      }}
                                    />
                                  );
                                })()}
                              </Box>

                              {/* Primary Action */}
                              {isOfferPreparation && primaryApprovalStatus !== "Approved" &&
                                primaryApprovalStatus !== "Rejected" && (
                                <Tooltip
                                  title={
                                    !isCloudPathAval
                                      ? "Unable to send for approval because the offer letter could not be generated successfully. Please edit and regenerate the offer letter before proceeding."
                                      : ""
                                  }
                                  arrow
                                >
                                <span>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    disabled={primaryApprovalDisabled || !isCloudPathAval}
                                    onClick={() => handleApprove({type: "primary", name: primaryApprover, email: jobMprInfo?.approver_email, approver_status: primaryApprovalStatus})}
                                    sx={{
                                      mt: 1,
                                      fontSize: "10px",
                                      textTransform: "none",
                                      py: 0.4,
                                      px: 1,
                                      borderRadius: "5px",
                                    }}
                                  >
                                    Send for Approval
                                  </Button>
                                </span>
                                </Tooltip>
                                )}
                            </Box>
                          </Box>

                          {/* SECONDARY - Only visible if Above Budget */}
                          {isAboveBudget && (
                            <Box
                              sx={{
                                position: "relative",
                              }}
                            >
                              <Box
                                sx={{
                                  position: "absolute",
                                  left: "-29px",
                                  top: 1,
                                  width: 20,
                                  height: 20,
                                  borderRadius: "50%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor:
                                    secondApprovalStatus === "Approved"
                                      ? "#16a34a"
                                      : primaryApprovalStatus === "Approved"
                                      ? "#f59e0b"
                                      : "#d0d5dd",
                                  color: "#fff",
                                  fontSize: "10px",
                                  fontWeight: 700,
                                  zIndex: 1,
                                }}
                              >
                                {secondApprovalStatus === "Approved" ? "✓" : "2"}
                              </Box>

                              <Box
                                sx={{
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "8px",
                                  p: 1.1,
                                  backgroundColor:
                                    secondApprovalStatus === "Approved"
                                      ? "#fbfffc"
                                      : primaryApprovalStatus === "Approved"
                                      ? "#fffdf7"
                                      : "#fafafa",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between",
                                    gap: 1,
                                  }}
                                >
                                  <Box sx={{ minWidth: 0 }}>
                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        color:
                                          primaryApprovalStatus === "Approved"
                                            ? "#344054"
                                            : "#98a2b3",
                                      }}
                                    >
                                      Secondary Approval
                                    </Typography>

                                    <Typography
                                      sx={{
                                        fontSize: "10px",
                                        color: "#667085",
                                        mt: 0.3,
                                      }}
                                    >
                                      {secondApprover || "-"}
                                    </Typography>
                                  </Box>

                                  {(() => {
                                    const { bg, text } = getStatusColor(secondApprovalStatus);
                                    return (
                                      <Chip
                                        label={secondApprovalStatus}
                                        size="small"
                                        sx={{
                                          height: 21,
                                          fontSize: "9px",
                                          fontWeight: 600,
                                          backgroundColor: bg,
                                          color: text,
                                        }}
                                      />
                                    );
                                  })()}
                                </Box>

                                {/* Secondary Action */}
                                {isOfferPreparation && primaryApprovalStatus === "Approved" &&
                                  secondApprovalStatus !== "Approved" &&
                                  secondApprovalStatus !== "Rejected" && (
                                  <Tooltip
                                    title={
                                      !isCloudPathAval
                                        ? "Unable to send for approval because the offer letter could not be generated successfully. Please edit and regenerate the offer letter before proceeding."
                                        : ""
                                    }
                                    arrow
                                  >
                                  <span>
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      disabled={secondaryApprovalDisabled || !isCloudPathAval}
                                      onClick={() => handleApprove({type: "secondary", name: secondApprover, email: jobMprInfo?.second_approver_email, approver_status: secondApprovalStatus})}
                                      sx={{
                                        mt: 1,
                                        fontSize: "10px",
                                        textTransform: "none",
                                        py: 0.4,
                                        px: 1,
                                        borderRadius: "5px",
                                      }}
                                    >
                                      Send for Approval
                                    </Button>
                                  </span>
                                  </Tooltip>
                                  )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    )}
              </Box>
              </TabPanel>
            </TabContext>
          </div>
          <div
            style={{
              flex: "1",
              height: isAiJob ? "505px" : "450px",
              overflowY: "auto",
              marginLeft: "10px",
            }}
          >
            <Divider sx={{ mb: 2 }} />
            <Grid container>
              <Grid item xs={12} md={12} sx={{ mb: 2 }}>
                <FormControl fullWidth sx={{ pr: 1 }}>
                  <TextField
                    disabled={true}
                    label="Propose By"
                    size="small"
                    fullWidth
                    variant="outlined"
                    value={
                      data?.proposed_by_name
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} sx={{ mb: 2 }}>
                <FormControl fullWidth sx={{ pr: 1 }}>
                  <SelectableSearch
                    isOptionEqualToValue={(option, value) =>
                      +option.recruiter_id === +value.recruiter_id
                    }
                    label="Assignee"
                    loading={() =>
                      setAssigneeData({ load: false, values: mentionUsers })
                    }
                    value={previewData?.assignee}
                    fieldLabel="display"
                    variant={"contained"}
                    size="small"
                    name="assignee"
                    data={assigneeData}
                    onChangeEvent={handleInputChange}
                  />
                </FormControl>
              </Grid>
              <Grid container item xs={12} md={12} alignItems="center" sx={{
                pr: 1, ...(isAdminOwner &&
                  (previewData?.stage_id.name === "Offer Accepted" || 
                    previewData?.stage_id.name === "Joined" || 
                    previewData?.stage_id.name === "Offer Released") 
                    && { border: "1px solid #ccc", borderRadius: "4px", pt: 1.5, pl: 0.5, boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.03)" })
              }} >
                <Grid item xs={12} md={12} sx={{ mb: 1.5 }}>
                  <FormControl fullWidth>
                    <SelectableSearch
                      isOptionEqualToValue={(option, value) =>
                        +option.ats_job_stages_id === +value.ats_job_stages_id
                      }
                      label="Select stage"
                      value={previewData?.stage_id}
                      // loading={() =>
                      //   setStagesData({ load: false, values: stageData })
                      // }
                      loading={() => handleStages()}
                      fieldLabel="name"
                      required={true}
                      variant={"contained"}
                      name="stage_id"
                      size="small"
                      data={stagesData}
                      onChangeEvent={handleInputChange}
                      {...(errors?.stage_id && {
                        error: true,
                        helperText: errors?.stage_id,
                      })}
                    />
                  </FormControl>
                </Grid>
                {isAdminOwner &&
                  (previewData?.stage_id.name === "Offer Accepted" || previewData?.stage_id.name === "Joined") && (
                    <>
                      <Grid item xs={12}><Divider sx={{ width: "100%" }} /></Grid>
                      <Box
                        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                      >
                        <Typography variant="body1" sx={{ m: 1 }}>
                          Offer Details
                        </Typography>
                        <IconButton
                          aria-label="toggle visibility"
                          onClick={() => setViewOffer(!viewOffer)}
                          size="small"
                        >
                          {viewOffer ? (
                            <VisibilityOffIcon sx={{ fontSize: "18px" }} />
                          ) : (
                            <VisibilityIcon sx={{ fontSize: "18px" }} />
                          )}
                        </IconButton>
                      </Box>
                      {!viewOffer ? (
                        <>
                          <FormControl fullWidth>
                            <TextField
                              sx={{ mb: "10px" }}
                              size="small"
                              value="*******"
                              variant="outlined"
                              fullWidth
                              id="joined_ctc"
                              label={
                                stageData?.findIndex(
                                  (obj) =>
                                    obj.ats_job_stages_id === previewData?.stage_id.ats_job_stages_id
                                ) ===
                                  stageData?.length - 1 ||
                                  previewData?.stage_id.name === "Joined"
                                  ? "Joined CTC"
                                  : "Accepted CTC"
                              }
                            />
                          </FormControl>
                          <FormControl fullWidth>
                            <TextField
                              sx={{ mb: "10px" }}
                              size="small"
                              value="*******"
                              variant="outlined"
                              fullWidth
                              id="joined_ctc"
                              label={
                                stageData?.findIndex(
                                  (obj) =>
                                    obj.ats_job_stages_id === previewData?.stage_id.ats_job_stages_id
                                ) ===
                                  stageData?.length - 1 ||
                                  previewData?.stage_id.name === "Joined"
                                  ? "Joined Date"
                                  : "Tentative Joining Date"
                              }
                            />
                          </FormControl>
                        </>
                      ) : stageData?.findIndex(
                        (obj) => obj.ats_job_stages_id === previewData?.stage_id.ats_job_stages_id
                      ) ===
                        stageData?.length - 1 ||
                        previewData?.stage_id.name === "Joined" ? (
                        <>
                          <FormControl fullWidth sx={{ mb: 1.5 }}>
                            <TextField
                              size="small"
                              type="number"
                              value={previewData?.joined_ctc}
                              onChange={handleInputChange}
                              variant="outlined"
                              fullWidth
                              id="joined_ctc"
                              label="Joined CTC"
                              name="joined_ctc"
                            />
                          </FormControl>
                          <FormControl fullWidth sx={{ mb: 1.5 }}>
                            <CommonDatePicker
                              size="small"
                              required
                              name="joined_date"
                              label="Joined Date"
                              pickerType="date"
                              onKeyDown={(e) => e.preventDefault()}
                              onKeyPress={(e) => e.preventDefault()}
                              pickerFormat="dd/MM/yyyy"
                              DefaultDTvalue={previewData?.joined_date}
                              handleChange={(value) =>
                                handleInputChange({
                                  target: {
                                    name: "joined_date",
                                    value: value
                                      ? `${value?.getFullYear() +
                                      "-" +
                                      ("0" + (value?.getMonth() + 1)).slice(
                                        -2
                                      ) +
                                      "-" +
                                      ("0" + value?.getDate()).slice(-2)
                                      }`
                                      : "",
                                  },
                                })
                              }
                              {...(errors.joined_date && {
                                error: true,
                                helperText: errors.joined_date,
                              })}
                            />
                          </FormControl>
                          <FormControl fullWidth sx={{ mb: 1.5 }}>
                            <TextField
                              size="small"
                              type="text"
                              value={previewData?.job_designation}
                              onChange={handleInputChange}
                              variant="outlined"
                              fullWidth
                              id="job_designation"
                              label="Designation"
                              name="job_designation"
                            />
                          </FormControl>
                          <FormControl fullWidth sx={{ mb: 1.5 }}>
                            <TextField
                              size="small"
                              type="text"
                              value={previewData?.job_location}
                              onChange={handleInputChange}
                              variant="outlined"
                              fullWidth
                              id="job_location"
                              label="Location"
                              name="job_location"
                            />
                          </FormControl>
                        </>
                      ) : (
                        (stageData?.findIndex(
                          (obj) => obj.ats_job_stages_id === previewData?.stage_id.ats_job_stages_id
                        ) ===
                          stageData?.length - 2 ||
                          previewData?.stage_id.name === "Offer Accepted") && (
                          <>
                            <FormControl fullWidth sx={{ mb: 1.5 }}>
                              <TextField
                                size="small"
                                type="number"
                                value={previewData?.accepted_ctc}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                id="accepted_ctc"
                                label="Accepted CTC"
                                name="accepted_ctc"
                              />
                            </FormControl>
                            <FormControl fullWidth sx={{ mb: 1.5 }}>
                              <CommonDatePicker
                                size="small"
                                required
                                name="tentative_joining_date"
                                label="Tentative Joining Date"
                                pickerType="date"
                                onKeyDown={(e) => e.preventDefault()}
                                onKeyPress={(e) => e.preventDefault()}
                                pickerFormat="dd/MM/yyyy"
                                DefaultDTvalue={previewData?.tentative_joining_date}
                                handleChange={(value) =>
                                  handleInputChange({
                                    target: {
                                      name: "tentative_joining_date",
                                      value: value
                                        ? `${value?.getFullYear() +
                                        "-" +
                                        ("0" + (value?.getMonth() + 1)).slice(
                                          -2
                                        ) +
                                        "-" +
                                        ("0" + value?.getDate()).slice(-2)
                                        }`
                                        : "",
                                    },
                                  })
                                }
                                {...(errors.tentative_joining_date && {
                                  error: true,
                                  helperText: errors.tentative_joining_date,
                                })}
                              />
                            </FormControl>
                          </>
                        )
                      )}
                    </>
                  )}
                {isAdminOwner &&
                  (previewData?.stage_id.name === "Offer Released") && (
                    <>
                      {/* offer_released_date */}
                      <FormControl fullWidth sx={{ mb: 1 }}>
                        <CommonDatePicker
                          size="small"
                          name="offer_released_date"
                          label="Offer Released Date"
                          pickerType="date"
                          onKeyDown={(e) => e.preventDefault()}
                          onKeyPress={(e) => e.preventDefault()}
                          pickerFormat="dd/MM/yyyy"
                          DefaultDTvalue={previewData?.offer_released_date}
                          handleChange={(value) =>
                            handleInputChange({
                              target: {
                                name: "offer_released_date",
                                value: value
                                  ? `${value?.getFullYear() +
                                  "-" +
                                  ("0" + (value?.getMonth() + 1)).slice(-2) +
                                  "-" +
                                  ("0" + value?.getDate()).slice(-2)
                                  }`
                                  : "",
                              },
                            })
                          }
                        />
                      </FormControl>
                    </>
                  )}
              </Grid>
              {isAdminOwner && previewData?.stage_id.name === "Joined" && ( 
                <Grid container item xs={12} md={12} alignItems="center"
                  sx={{
                    pr: 1, pt: 0.5, ...(previewData?.mpr_info && isMprReplacement &&
                      { mt: 0.5, border: "1px solid #ccc", borderRadius: "4px", pt: 1, pl: 0.5, boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.03)" })
                  }}
                >
                  <Grid item xs={12} md={12}>
                    <FormControl fullWidth sx={{ mb: "10px", mt: 1 }}>
                        <SelectableSearch
                          isOptionEqualToValue={(option, value) =>
                            +option?.mpr_id === +value?.mpr_id
                          }
                          label="MPR"
                          required={false}
                          value={
                            previewData?.mpr_info
                              ? {
                                  ...previewData.mpr_info,
                                  mpr_display:
                                    previewData.mpr_info?.mpr_display ||
                                    (previewData.mpr_info?.hiring_type
                                      ? `${previewData.mpr_info.mpr_no} - ${previewData.mpr_info.hiring_type}`
                                      : previewData.mpr_info.mpr_no),
                                }
                              : null
                          }
                          loading={() => handleMPROption()}
                          fieldLabel="mpr_display"
                          variant={"contained"}
                          name="mpr_info"
                          size="small"
                          data={mprData}
                          onChangeEvent={handleInputChange}
                          {...(errors.mpr_info && {
                            error: true,
                            helperText: errors.mpr_info,
                          })}
                        />
                      </FormControl>
                  </Grid>   
                  {/* // when replacement MPR is selected then - Capture the replacing employee ID, employee name, CTC, target date for hiring. */}
                  {isMprReplacement && (() => {
                    const repOptions = (() => {
                      let repDetails = [];
                      if (typeof previewData?.mpr_info?.replacement_details === "string") {
                        try { repDetails = JSON.parse(previewData.mpr_info.replacement_details) || []; } catch (e) {}
                      } else if (Array.isArray(previewData?.mpr_info?.replacement_details)) {
                        repDetails = previewData.mpr_info.replacement_details;
                      }
                      if (!Array.isArray(repDetails) || repDetails.length === 0) return [];

                      let alreadyReplaced = [];
                      if (Array.isArray(previewData?.mpr_info?.mpr_jobpost_replacement_details)) {
                        previewData.mpr_info.mpr_jobpost_replacement_details.forEach((rep) => {
                          if (rep?.replacement_employee_name && (!data?.candidate_job_id || +rep?.candidate_job_pk !== +data?.candidate_job_id)) {
                            alreadyReplaced.push(rep.replacement_employee_name.trim().toLowerCase());
                          }
                        });
                      }

                      return repDetails.map((item) => {
                        const name = item.name || item.full_name || "";
                        const isReplaced = alreadyReplaced.includes(name.trim().toLowerCase());
                        return {
                          ...item,
                          name: name,
                          designation: item.designation || "",
                          ctc: item.ctc || "",
                          isReplaced: isReplaced,
                        };
                      });
                    })();

                    const hasDropdown = repOptions.length > 0;

                    return (
                      <>
                        <Grid item xs={12} md={12}>
                          {hasDropdown ? (
                            <FormControl fullWidth sx={{ mb: "10px" }} size="small">
                              <InputLabel id="preview-replacement-person-name-label">Replacement Person Name</InputLabel>
                              <Select
                                labelId="preview-replacement-person-name-label"
                                id="replacement_employee_name"
                                name="replacement_employee_name"
                                value={previewData?.replacement_employee_name || ""}
                                label="Replacement Person Name"
                                onChange={(e) => {
                                  const selectedName = e.target.value;
                                  const matched = repOptions.find((r) => r.name === selectedName);
                                  setPreviewData({
                                    ...previewData,
                                    replacement_employee_name: selectedName,
                                    replacement_employee_designation: matched?.designation || "",
                                    replacement_ctc: matched?.ctc || "",
                                  });
                                }}
                              >
                                {repOptions.map((opt, idx) => (
                                  <MenuItem
                                    key={idx}
                                    value={opt.name}
                                    disabled={opt.isReplaced}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      opacity: opt.isReplaced ? 0.6 : 1,
                                    }}
                                  >
                                    <span>{opt.name}</span>
                                    {opt.isReplaced && (
                                      <span style={{ color: "#d32f2f", fontSize: "12px", fontWeight: 600, marginLeft: "12px" }}>
                                        - Replaced
                                      </span>
                                    )}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          ) : (
                            <FormControl fullWidth sx={{ mb: "10px" }}>
                              <TextField
                                size="small"
                                value={previewData?.replacement_employee_name || ""}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                id="replacement_employee_name"
                                label="Replacement Person Name"
                                name="replacement_employee_name"
                              />
                            </FormControl>
                          )}
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <FormControl fullWidth sx={{ mb: "10px" }}>
                            <TextField
                              size="small"
                              value={previewData?.replacement_employee_designation || ""}
                              onChange={handleInputChange}
                              variant="outlined"
                              fullWidth
                              disabled={hasDropdown}
                              id="replacement_employee_designation"
                              label="Current Designation"
                              name="replacement_employee_designation"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <FormControl fullWidth sx={{ mb: "10px" }}>
                            <TextField
                              size="small"
                              type="number"
                              value={previewData?.replacement_ctc || ""}
                              onChange={handleInputChange}
                              variant="outlined"
                              fullWidth
                              disabled={hasDropdown}
                              id="replacement_ctc"
                              label="Current CTC"
                              name="replacement_ctc"
                            />
                          </FormControl>
                        </Grid>
                      </>
                    );
                  })()}
                </Grid>
                )}
              {!["Joined","Rejected", "Offer Rejected"].includes(previewData?.stage_id?.name) && (
                <Grid item xs={12} md={12}>
                  <FormControl fullWidth sx={{ pr: 1, mb: 1.5, mt: 1}}>
                    <CommonDatePicker
                      size="small"
                      name="interview_date"
                      label="Interview Date"
                      pickerType="date"
                      onKeyDown={(e) => e.preventDefault()}
                      onKeyPress={(e) => e.preventDefault()}
                      pickerFormat="dd/MM/yyyy"
                      DefaultDTvalue={previewData?.interview_date || null}
                      handleChange={(value) =>
                        handleInputChange({
                          target: {
                            name: "interview_date",
                            value: value
                              ? `${value?.getFullYear() +
                              "-" +
                              ("0" + (value?.getMonth() + 1)).slice(-2) +
                              "-" +
                              ("0" + value?.getDate()).slice(-2)
                              }`
                              : "",
                          },
                        })
                      }
                    />
                  </FormControl>
                </Grid>
              )}
              <Grid item xs={12} md={12}>
                <FormControl fullWidth sx={{ pr: 1, mb: 1.5, mt: 1}}>
                  <CreatableSearch
                    isOptionEqualToValue={(option, value) =>
                      +option.ats_status_id === +value.ats_status_id
                    }
                    label="Select Status"
                    value={previewData?.ats_status_id}
                    fieldLabel="name"
                    loading={() => handleStatusData()}
                    required={false}
                    variant={"contained"}
                    name="ats_status_id"
                    size="small"
                    data={statusData}
                    onChangeEvent={handleInputChange}
                  />
                </FormControl>
              </Grid>
              {previewData?.stage_id.name === "Rejected" && (
                <FormControl
                  size="small"
                  required
                  fullWidth
                  sx={{ pr: 1 }}
                  error={errors?.reason ? true : false}
                >
                  <InputLabel id="recruiter-type-select-label">
                    Reason
                  </InputLabel>
                  <Select
                    name="rejected_reason"
                    id="rejected_reason"
                    value={previewData?.rejected_reason}
                    label="Status"
                    onChange={handleInputChange}
                    {...(errors.rejected_reason && {
                      error: true,
                      helperText: errors.rejected_reason,
                    })}
                  >
                    <MenuItem value={"Fake Candidate"}>Fake Candidate</MenuItem>
                    <MenuItem value={"Technical Reject"}>
                      Technical Reject
                    </MenuItem>
                    <MenuItem value={"Cultural Reject"}>
                      Cultural Reject
                    </MenuItem>
                    <MenuItem value={"No Show"}>No Show</MenuItem>
                    <MenuItem value={"Doesn't fit the role"}>
                      Doesn't Fit The Role
                    </MenuItem>
                    <MenuItem value={"Internal approval rejected"}>
                      Internal Approval Rejected
                    </MenuItem>
                    <MenuItem value={"Salary Fitment Issue"}>
                      Salary Fitment Issue
                    </MenuItem>
                    <MenuItem value={"BGV Issue"}>
                      BGV Issue
                    </MenuItem>
                  </Select>
                  <FormHelperText>{errors?.reason}</FormHelperText>
                </FormControl>
              )}

              {data.job_stage_name === "Rejected" && (
                <>
                <FormControl fullWidth sx={{ pr: 1, mt: 1 }}>
                  <TextField
                    label={"Reverting the Rejection Reason"}
                    name="reverting_reason"
                    id="reverting_reason"
                    multiline
                    rows={4}
                    variant="outlined"
                    value={previewData?.reverting_reason}
                    fullWidth
                    onChange={handleInputChange}
                    {...(errors.reverting_reason && {
                      error: true,
                      helperText: errors.reverting_reason,
                    })}
                  />
                </FormControl>
                </>
              )}
              <Grid item xs={12} md={12} mt={1}>
                <Typography sx={{ pl: 1 }}>Feedback Score</Typography>
                <CustomRating
                  max={10}
                  name={"priority"}
                  value={previewData?.priority}
                  handleInputChange={handleInputChange}
                />
              </Grid>
            </Grid>
            <div style={{ position: "relative", margin: "1px 7px 0px 0px"}}>
              <MentionsInput
                style={MentionInputStyles}
                value={mentionValue}
                onChange={(e, id) => handleChange(e, id)}
                placeholder={"Mention people using '@'"}
                
              >
                <Mention
                  displayTransform={(ats_users_id, first_name) =>
                    `@${first_name}`
                  }
                  data={mentionUsers}
                  displayName="first_name"
                />
              </MentionsInput>
              <IconButton
                sx={{
                  position: "absolute",
                  bottom: "1px",
                  right: "5px",
                  zIndex: 1,
                  pointerEvents: mentionValue.trim() === "" ? "none" : "auto",
                }}
                disabled={mentionValue.trim() === ""}
              >
                <Tooltip title="Send">
                  <SendIcon
                    onClick={() => handleSubmit("YES")}
                    sx={{
                      cursor: mentionValue.trim() === "" ? "not-allowed" : "pointer",
                      color: mentionValue.trim() === ""
                        ? "grey"
                        : theme?.palette?.primary?.main,
                    }}
                    fontSize="small"
                  />
                </Tooltip>
              </IconButton>

            </div>
            <Box
              padding="16px 5px 16px 5px"
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              {data.job_stage_name === "Joined" ? (
                <Tooltip
                  title={
                    data?.access_onboard_candidate === false ||
                      data?.access_onboard_candidate === null
                      ? "You don't have sufficient permission to perform this action. Please contact Admin."
                      : ""
                  }
                >
                  <div>
                    <Button
                      disabled={
                        data?.is_onboarded === true ||
                        data?.access_onboard_candidate === false ||
                        data?.access_onboard_candidate === null
                      }
                      className="mpl-primary-btn"
                      size="medium"
                      variant="contained"
                      onClick={() => handleOnboarding()}
                    >
                      Onboard Candidate
                    </Button>
                  </div>
                </Tooltip>
              ) : (
                <ButtonGroup
                  disabled={!data?.feedback_template_id}
                  variant="contained"
                  ref={anchorRef}
                  aria-label="split button"
                >
                  <Button
                    style={{ borderColor: theme?.palette?.primary?.main }}
                    className="mpl-primary-btn"
                    onClick={handleClick}
                  >
                    {options[selectedIndex]}
                  </Button>
                  <Button
                    className="mpl-primary-btn"
                    size="small"
                    aria-controls={open ? "split-button-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                  >
                    <ArrowDropDownIcon />
                  </Button>
                </ButtonGroup>
              )}
              <Button
                className="mpl-primary-btn"
                size="medium"
                variant="contained"
                onClick={handleSubmit}
              >
                Update
              </Button>
            </Box>
            <Popper
              sx={{
                zIndex: 1,
              }}
              open={open}
              anchorEl={anchorRef.current}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList id="split-button-menu" autoFocusItem>
                        {options.map((option, index) => (
                          <MenuItem
                            key={option}
                            selected={index === selectedIndex}
                            onClick={(event) =>
                              handleMenuItemClick(event, index)
                            }
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>
        </div>
        {/* PreScreening Response */}
        <Box position={"relative"}>
          <AICongifWarningPopup
            ref={aiConfigPopupRef}
            validateFor="JD"
            closeReq={true}
          />
          {isAiJob && showResponse && (
            <Box ref={prescreenRef}>
              <PreScreenResponseViewer data={data} handleGenerateScreeningScore={handleGenerateScreeningScore}
                useGeneratedScore={shouldGenerateScore}
              />
            </Box>
          )}
        </Box>
        <Popup
          fullWidth={true}
          maxWidth="md"
          title="Notes"
          openPopup={openNotes}
          setOpenPopup={setOpenNotes}
        >
          <div>
            <Divider sx={{ borderStyle: "dashed" }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: "100%" }}>
                <InputBase
                  value={data?.notes}
                  multiline
                  rows={15}
                  fullWidth
                  name="notes"
                  disabled
                  sx={{ padding: "5px 0px" }}
                  placeholder="Notes About Candidate..."
                />
              </Box>
            </Box>
            <Divider sx={{ borderStyle: "dashed" }} />
          </div>
        </Popup>
        <Popup
          fullWidth={true}
          maxWidth="sm"
          title="Confirmation"
          openPopup={openprescreen}
          setOpenPopup={setOpenPreScreen}
        >
          <Typography variant="h6">
            Do you want to send mail to candidate ?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", m: 2 }}>
            <Button
              className="mpl-secondary-btn"
              variant="outlined"
              onClick={(e) => setOpenPreScreen(false)}
            >
              Skip
            </Button>
            <Button
              className="mpl-primary-btn"
              variant="contained"
              onClick={handleSend}
              sx={{ ml: 2 }}
            >
              Send Mail
            </Button>
          </Box>
        </Popup>
        <Popup
          fullWidth
          maxWidth="xl"
          title="Preview Offer Letter"
          isMasterProduct={false}
          setOpenPopup={setIsOfferView}
          openPopup={isofferview}
        >
          <ViewOffer data={{ ...data, ...(historyData || {}), ...(previewData || {}) }} />
        </Popup>
        <Popup
          fullWidth
          maxWidth="xl"
          title={data?.full_name ? `Edit Offer Letter - ${data.full_name}` : "Edit Offer Letter"}
          isMasterProduct={false}
          setOpenPopup={setIsOfferEdit}
          openPopup={isofferedit}
        >
          <OfferLetterResponseStepper
            currentData={data}
            currentJobData={currentJobData}
            setIsOfferForm={setIsOfferEdit}
            setElements={setElements}
            OfferEdit={"true"}
            setCurrentData={setCurrentData}
          />
        </Popup>
        <Popup
          maxWidth="xs"
          title="⚠️ Alert"
          isMasterProduct={true}
          setOpenPopup={setOpenEditOfferAlert}
          openPopup={openEditOfferAlert}
        >
          <Box sx={{ p: 1, textAlign: "center" }}>
            <Typography sx={{ textAlign: "center", fontSize: "16px", mb: 3 }}>
              Edit offer letter will generate a new offer letter and replace the previously generated version
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button
                variant="outlined"
                sx={{ borderColor: "#cbd5e1", color: "#475569" }}
                onClick={() => setOpenEditOfferAlert(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="mpl-primary-btn"
                onClick={() => {
                  setOpenEditOfferAlert(false);
                  setIsOfferEdit(true);
                }}
              >
                Confirm
              </Button>
            </Box>
          </Box>
        </Popup>
      </Box>
    </>
  );
};


const getStatusColor = (status) => {
  switch (status) {
    case "Awaiting for Approval":
    case "Awaiting Approval":
    case "Pending Approval":
    case "Pending":
    case "Awaiting Second Approval":
    case "Awaiting Third Approval":
      return { bg: "#FFF4E5", text: "#FFA726" };

    case "Approved":
    case "Within Budget":
      return { bg: "#E8F5E9", text: "#66BB6A" };

    case "Rejected":
    case "Cancelled":
    case "Above Budget":
      return { bg: "#FFEBEE", text: "#EF5350" };

    case "Not Required":
    case "Submitted":
      return { bg: "#E3F2FD", text: "#42A5F5" };

    default:
      return { bg: "#E5E7EB", text: "#374151" };
  }
};
const BudgetStatusChip = ({ candidateCtc, budget }) => {
  const isAbove =
    Number(budget || 0) > 0 && Number(candidateCtc || 0) > Number(budget || 0);
  const status = isAbove ? "Above Budget" : "Within Budget";

  const { bg, text } = getStatusColor(status);

  return (
    <Chip
      label={status}
      size="small"
      sx={{
        height: 21,
        fontSize: "9px",
        fontWeight: 600,
        backgroundColor: bg,
        color: text,
      }}
    />
  );
};
export default AtsCandidatePreview;
